var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"WaitingPeriod"},[(_vm.mobileMode)?_c('div',{staticClass:"WaitingPeriod-message--mobile"},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_c('div',{staticClass:"WaitingPeriod-message"},[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }